import React from 'react';      // Import React
import ReactDOM from 'react-dom'; // Import ReactDOM
import App from './App';        // Import the main App component

// Render the App component into the root element
ReactDOM.render(<App />, document.getElementById('root'));
